import { GetterTree } from "vuex/types"

import { RootState } from "~/store/store.types"
import { EnvironmentState, ThemeColor } from "./environment.types"

const getters: GetterTree<EnvironmentState, RootState> = {
  isWebview ({ webview }) {
    return webview
  },

  themeColor ({ theme }) {
    return theme.color || theme.defaultColor
  },

  isDarkTheme (_, { themeColor }) {
    return ThemeColor.Dark === themeColor
  }
}

export default getters
